import _ from 'lodash'

import { TableColumn } from 'components/Table/Table'

import i18n from 'translations'

export const TABLE_COLUMNS: TableColumn[] = [
  {
    align: 'left',
    alignTh: 'left',
    field: 'takenAt',
    title: i18n.t('global:Date'),
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'child',
    title: _.upperFirst(i18n.t('global:child')),
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'medication',
    title: i18n.t('module:Safeguarding:Administration:List:Table:medication'),
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'frequency',
    title: i18n.t('module:Safeguarding:Administration:List:Table:frequency'),
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'timeOfAdministration',
    title: i18n.t('global:Time'),
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'type',
    title: i18n.t('module:Safeguarding:Administration:List:Table:administrationType'),
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'administeredBy',
    title: i18n.t('module:Safeguarding:Administration:List:Table:administeredBy'),
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'status',
    title: _.upperFirst(i18n.t('global:status')),
  },
  {
    align: 'left',
    alignTh: 'left',
    field: 'parentSignatureAction',
    title: i18n.t('global:Actions'),
  },
  {
    field: 'actions',
  },
]
